import Notification from '../base/notification'
import * as constants from '../../utils/constants'

const PREFIX_MESSAGE_CLASS = `${constants.PREFIX_CLASS}message`
const prefixKey = 'aid_message_key_'

let defaultDuration = 1.5
let top
let messageInstance
let name = 1
const iconTypes = {
  info: 'information-outline',
  success: 'check-circle-outline',
  warning: 'alert-outline',
  danger: 'close-circle-outline',
  loading: 'loading'
}
function getMessageInstance() {
  messageInstance =
    messageInstance ||
    Notification.newInstance({
      prefixCls: PREFIX_MESSAGE_CLASS,
      styles: {
        top: `${top}px`
      }
    })
  return messageInstance
}
function notice(content, type, onClose, duration = defaultDuration) {
  if (!onClose) {
    onClose = function() {}
  }
  const iconType = iconTypes[type]
  // if loading
  const loadCls =
    type === 'loading' ? ` ${constants.PREFIX_ICON_CLASS}ani-loop` : ''
  // 实例化一个notification对象
  let instance = getMessageInstance()
  instance.notice({
    name: `${prefixKey}${name}`,
    duration: duration,
    styles: {},
    transitionName: 'move-up',
    content: `
            <div class="${PREFIX_MESSAGE_CLASS}-custom-content ${PREFIX_MESSAGE_CLASS}-${type}">
                <i class="${constants.CLASS_MAIN} ${
  constants.CLASS_MAIN
}-icon ${constants.PREFIX_ICON_CLASS}${iconType}${loadCls}"></i>
                <span>${content}</span>
            </div>
        `,
    onClose: onClose
  })
  // 用于手动消除
  return (function() {
    let target = name++
    return function() {
      instance.remove(`${prefixKey}${target}`)
    }
  })()
}
export default {
  info(content, duration, onClose) {
    return notice(content, 'info', onClose, duration)
  },
  success(content, duration, onClose) {
    return notice(content, 'success', onClose, duration)
  },
  warning(content, duration, onClose) {
    return notice(content, 'warning', onClose, duration)
  },
  danger(content, duration, onClose) {
    return notice(content, 'danger', onClose, duration)
  },
  loading(content, duration, onClose) {
    return notice(content, 'loading', onClose, duration)
  },
  config(options) {
    if (options.top) {
      top = options.top
    }
    if (options.duration) {
      defaultDuration = options.duration
    }
  },
  destroy() {
    // 在销毁时判断是否有notification对象，有则获取，没有则创建一个空的notification对象
    let instance = getMessageInstance()
    messageInstance = null
    instance.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/components/message/index.js